import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex rating border border-2 p-2 rounded-xl leading-4", [_ctx.colorClass, _ctx.fillClass, _ctx.className]])
  }, _toDisplayString(_ctx.score || '-'), 3))
}